export enum AllocationType {
    MANUAL = "MANUAL",
    AUTO = "AUTO"
}
